export type NotificationFilter = {
    sort?: NotificationSortOptions;
    order?: NotificationOrderOptions;
};

export enum NotificationSortOptions {
    NONE,
    CREATION_DATE,
    CLEARED_DATE,
    STATUS,
}

export enum NotificationOrderOptions {
    ASC,
    DESC,
}

export type NotificationCounts = {
    open: number;
    cleared: number;
};
